import { SET_SELECTED_SHIP } from '../actions/constants';

const defaultState = {
  selectedShip: null,

  // For debugging purposes:
  // selectedShip: {
  //   id: 115,
  //   status: 'active',
  //   eni: '02331666',
  //   name: 'Admiral',
  //   created_at: '2014-01-01T00:00:00',
  //   updated_at: '2024-02-29T09:48:16.935928',
  //   deleted_at: null,
  //   sensor_activity: {
  //     ship_id: 115,
  //     gsm_signal_strength: '2024-04-11T10:20:04',
  //     gps_lat: '2024-04-11T10:20:04',
  //     gps_lon: '2024-04-11T10:20:04',
  //     gps_vdop: null,
  //     gps_hdop: '2024-04-11T10:20:04',
  //     echosounder_depth: '2024-04-11T10:20:04',
  //     echosounder_vertical_offset: '2024-04-11T10:20:04',
  //     loading_ps_fore: '2024-04-11T10:20:04',
  //     loading_sb_fore: '2024-04-11T10:20:04',
  //     loading_ps_mid: '2024-04-11T10:20:04',
  //     loading_sb_mid: '2024-04-11T10:20:04',
  //     loading_ps_aft: '2024-04-11T10:20:04',
  //     loading_sb_aft: '2024-04-11T10:20:04',
  //     metadata: {
  //       id: 10994703232,
  //       ship_eni: 2331666,
  //       gsm_signal_strength: -73,
  //       gps_lat: 51.814567,
  //       gps_lon: 5.373333,
  //       gps_bearing: null,
  //       gps_vdop: null,
  //       gps_hdop: 1,
  //       gps_heading: 208.3,
  //       gps_course_over_ground: null,
  //       gps_speed_over_ground: 5.289942072384,
  //       gps_heading_true: null,
  //       gps_heading_magnetic: null,
  //       gps_magnetic_variation: null,
  //       gps_mode: 2,
  //       echosounder_depth: 7.12,
  //       echosounder_vertical_offset: 0,
  //       cargo_weight: 0,
  //       trim: null,
  //       draft_average: 0,
  //       draft_manual_fore: null,
  //       draft_manual_aft: null,
  //       loading_ps_fore: 0.71,
  //       loading_sb_fore: 0.71,
  //       loading_ps_mid: 1.05,
  //       loading_sb_mid: 1.05,
  //       loading_ps_aft: 1.3900000000000001,
  //       loading_sb_aft: 1.3900000000000001,
  //       loading_roll: 0,
  //       loading_sagging: 0,
  //       loading_frequency: null,
  //       loading_quality: null,
  //       wind_direction: null,
  //       wind_speed: null,
  //       engine1_fuel_flow: null,
  //       engine1_fuel_per_km: null,
  //       engine1_rpm: null,
  //       engine1_co2: null,
  //       engine1_ureum: null,
  //       engine1_exhaust_pressure: null,
  //       engine1_exhaust_temperature: null,
  //       engine1_hours: null,
  //       engine1_nox: null,
  //       engine1_power: null,
  //       engine2_fuel_flow: null,
  //       engine2_fuel_per_km: null,
  //       engine2_rpm: null,
  //       engine2_co2: null,
  //       engine2_ureum: null,
  //       engine2_exhaust_pressure: null,
  //       engine2_exhaust_temperature: null,
  //       engine2_hours: null,
  //       engine2_nox: null,
  //       engine2_power: null,
  //       engine3_fuel_flow: null,
  //       engine3_fuel_per_km: null,
  //       engine3_rpm: null,
  //       engine3_co2: null,
  //       engine3_ureum: null,
  //       engine3_exhaust_pressure: null,
  //       engine3_exhaust_temperature: null,
  //       engine3_hours: null,
  //       engine3_nox: null,
  //       engine3_power: null,
  //       engine4_fuel_flow: null,
  //       engine4_fuel_per_km: null,
  //       engine4_rpm: null,
  //       engine4_co2: null,
  //       engine4_ureum: null,
  //       engine4_exhaust_pressure: null,
  //       engine4_exhaust_temperature: null,
  //       engine4_hours: null,
  //       engine4_nox: null,
  //       engine4_power: null,
  //       rate_of_turn: null,
  //       rudder_angle_ps: null,
  //       rudder_angle_sb: null,
  //       date_time: '2024-04-11T10:20:04',
  //       water_depth: 8.186,
  //       echosounder_depth_smoothed: 7.12,
  //       echosounder_lat: 51.81385083383521,
  //       echosounder_lon: 5.372710850655298,
  //       cargo_weight_nim: 0,
  //       draft_aft_nim: 1.38,
  //       draft_fore_nim: 0.71,
  //       ship_id: 115,
  //     },
  //     date_time: '2024-04-11T10:20:04',
  //   },
  // },
};

const shipsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_SELECTED_SHIP: {
      return {
        ...state,
        selectedShip: { ...action.ship },
      };
    }
    default:
      return state;
  }
};

export default shipsReducer;
